module.exports = __webpack_public_path__ + "img/no-results-02.5c523860.webp";